// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Customer } from './customer';
import { InvoiceLine } from './invoice-line';
import { LoadAdditive } from './load-additive';
import { Product } from './product';
import { ProductLocation } from './product-location';
import { TicketAttachment } from './ticket-attachment';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Load extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get ticketAttachmentTypeName() {
        return this.ticketAttachment ? (this.ticketAttachment.typeId === 1 ? 'Scale' : this.ticketAttachment.typeId === 2 ? 'Redi-Mix' : '') : 'Manual';
    }

    get loadAdditivesDisplay() {
        let additives = [];
        if (this.loadAdditives?.length > 0) {
            this.loadAdditives.forEach((additive) => {
                additives.push(`Name: ${additive.name}, Qty: ${additive.loadYards}`);
            });
        }
        return additives.join('; ');
    }

    loadAdditivesHtml?: string;
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  additive1?: string;
  additive2?: string;
  additive3?: string;
  additive4?: string;
  additive5?: string;
  application?: string;
  carrier?: string;
  cash?: string;
  city?: string;
  conditions?: string;
  contact?: string;
  created!: Date;
  customerId?: number;
  customerString?: string;
  deleted?: Date;
  deliveryPrice!: number;
  deliveryProductId?: number;
  description1?: string;
  description2?: string;
  description3?: string;
  driver?: string;
  endTime?: Date;
  freightFob?: string;
  freightMode?: string;
  freightPayUnit?: string;
  freightRateType?: string;
  freightStatus?: string;
  freightType?: string;
  freightUnit?: string;
  grossWeight!: number;
  haulAmount!: number;
  haulPay!: number;
  haulPayAmount!: number;
  haulRate!: number;
  itemNumber!: number;
  loadDate!: Date;
  loadTotal!: number;
  locationId?: number;
  locationString?: string;
  manaulHasDelivery!: boolean;
  materialUnit?: string;
  mixString?: string;
  netWeight!: number;
  onHold?: Date;
  order?: string;
  orderBalance!: number;
  orderBeginBalance!: number;
  orderEndBalance!: number;
  orderedYards!: number;
  placeholder1?: string;
  placeholder2?: string;
  placeholder3?: string;
  placeholder4!: number;
  placeholder5?: string;
  placeholder6?: string;
  placeholder7!: number;
  poNumber?: string;
  post?: string;
  price!: number;
  priceVerified?: Date;
  productId?: number;
  productString?: string;
  quotedPrice!: boolean;
  recipePrice!: number;
  sack!: number;
  sellBuy?: string;
  shipReceive?: string;
  startTime?: Date;
  state?: string;
  tareWeight!: number;
  tax!: number;
  taxCodeString?: string;
  temperature?: string;
  ticketAttachmentId?: number;
  ticketNumber!: number;
  time!: string;
  uniqueId!: number;
  unitOfMeasure?: string;
  unitPrice!: number;
  vehicle?: string;
  void?: string;
  weightQuantity!: number;
  yardQuantity!: number;
  zip?: string;
  zipFourDigits?: string;
  zone?: string;
  customer!: Customer;
  deliveryProduct!: Product;
  invoiceLines!: InvoiceLine[];
  loadAdditives!: LoadAdditive[];
  location!: ProductLocation;
  product!: Product;
  ticketAttachment!: TicketAttachment;
}

